<div class="modal-body" #modalBody style="width: 1000px;">
  <div class="close-modal-button" (click)="closeModal()">&#x2716;</div>
  <ngb-carousel [activeId]="activeIndex">
    <ng-template ngbSlide [id]="i" *ngFor="let image of images; let i = index">
      <img [src]="image" alt="Image" style="width: 100%;"/>
    </ng-template>
  </ngb-carousel>
</div>
